import React, { Component } from "react";
import calcularPx from "../calcularPx";
import { Link } from "react-router-dom";
import { CSSTransition } from "react-transition-group";
import { ReactComponent as IcoChevron } from "../../../res/iconos/chevron.svg";

class RegionMobile extends Component {
  state = { mostrarSubmenu: false };

  style1 = {
    position: "relative",
    display: "block",
    width: "100%",
    padding: calcularPx(30) + " " + calcularPx(0),
    textAlign: "left",
    alignItems: "baseline",
    background: "transparent",
    border: "none",
  };

  style2 = {
    position: "relative",
    display: "block",
    color: "#3f3f46",
    padding: calcularPx(30) + " " + calcularPx(15),
    textDecoration: "none",
    fontFamily: "Open Sans",
    fontSize: calcularPx(16),
    fontWeight: 700,
    background: "transparent",
    border: "none",
  };

  render() {
    const { ocultar, setRegion } = this.props;
    return (
      <React.Fragment>
        <div
          style={{
            height: 1,
            width: "96.56%",
            backgroundColor: "#C4C4C4",
            marginTop: calcularPx(25),
          }}
        />
        <div>
          <button
            className={"itemNavBar"}
            style={this.style1}
            onClick={() => {
              this.setState({ mostrarSubmenu: !this.state.mostrarSubmenu });
            }}
          >
            <img 
              src={require(`../../../res/iconos/region_int.png`)} 
              style={{
                height: 25,
                position: "relative",
                display: "inline",
                marginRight: calcularPx(20),
              }}
            />
            Región
            <IcoChevron
              width={calcularPx(15)}
              height={calcularPx(15)}
              style={{
                position: "absolute",
                left: "90%",
                transform:
                  "scaleY(" + (this.state.mostrarSubmenu ? -1 : 1) + ")",
              }}
            />
          </button>
          <CSSTransition
            in={this.state.mostrarSubmenu}
            timeout={100}
            classNames="opacidad"
            unmountOnExit
          >
            <nav
              className={"submenuProductos"}
              style={{
                background: "#ffffff",
                position: "relative",
                marginLeft: "2%",
                marginRight: "2%",
                marginBottom: 10,
                top: 5,
                paddingLeft: 15,
                paddingTop: 15,
                paddingBottom: 15,
                paddingRight: 15,
                width: "auto",
                background: "#ffffff",
                borderRadius: 25
              }}
            >
              <button
                onClick={() => {
                  this.setState({ mostrarSubmenu: false });
                  ocultar();
                  setRegion('ar');
                }}
                style={this.style2}
              >
                <img 
                  src={require(`../../../res/iconos/region_ar.png`)} 
                  style={{
                    height: 25,
                    position: "relative",
                    display: "inline",
                    marginRight: calcularPx(20),
                  }}
                />
                Argentina
              </button>
              <button
                onClick={() => {
                  this.setState({ mostrarSubmenu: false });
                  ocultar();
                  setRegion('cl');
                }}
                style={this.style2}
              >
                <img 
                  src={require(`../../../res/iconos/region_cl.png`)} 
                  style={{
                    height: 25,
                    position: "relative",
                    display: "inline",
                    marginRight: calcularPx(20),
                  }}
                />
                Chile
              </button>
              <button
                onClick={() => {
                  this.setState({ mostrarSubmenu: false });
                  ocultar();
                  setRegion('bo');
                }}
                style={this.style2}
              >
                <img 
                  src={require(`../../../res/iconos/region_bo.png`)} 
                  style={{
                    height: 25,
                    position: "relative",
                    display: "inline",
                    marginRight: calcularPx(20),
                  }}
                />
                Bolivia
              </button>
              <button
                onClick={() => {
                  this.setState({ mostrarSubmenu: false });
                  ocultar();
                  setRegion('mx');
                }}
                style={this.style2}
              >
                <img 
                  src={require(`../../../res/iconos/region_mx.png`)} 
                  style={{
                    height: 25,
                    position: "relative",
                    display: "inline",
                    marginRight: calcularPx(20),
                  }}
                />
                México
              </button>
            </nav>
          </CSSTransition>
        </div>
      </React.Fragment>
    );
  }
}

export default RegionMobile;
